import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCross = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.70002 8.00002L12.25 11.55L11.55 12.25L8.00002 8.70002L4.35002 12.35L3.65002 11.65L7.30002 8.00002L3.65002 4.35002L4.35002 3.65002L8.00002 7.30002L11.65 3.65002L12.35 4.35002L8.70002 8.00002Z",
		fill: "currentColor"
	})
});
export default SvgCross;
